module.exports = __webpack_public_path__ + "assets/img/xiuli-fb430329.png";